import React from 'react';
import { Card, Grid, Typography, CircularProgress, Box, Chip } from '@mui/material';

const SnowflakeDataSourceDetail = ({ dataSource, loading, error }) => {
    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                style={{ marginTop: '30px', height: '400px' }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Grid item xs={12}>
                <Card variant="outlined" sx={{ padding: '20px', backgroundColor: 'error.light' }}>
                    <Typography variant="h6" color="error">
                        Error Loading Data Source
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {error}
                    </Typography>
                </Card>
            </Grid>
        );
    }

    if (!dataSource) {
        return null;
    }

    const allowedRoles = dataSource.allowedRolesCsv
        ? dataSource.allowedRolesCsv.split(',').map(r => r.trim()).filter(r => r)
        : [];

    return (
        <Grid item xs={12} sx={{ marginBottom: '20px' }}>
            <Card variant="outlined" sx={{ padding: '20px' }}>
                <Typography variant="h4" gutterBottom>
                    {dataSource.database}.{dataSource.schema}
                </Typography>
                <Typography variant="body1" paragraph color="text.primary">
                    <strong>Warehouse:</strong> {dataSource.warehouse}
                </Typography>
                <Typography variant="body1" paragraph color="text.primary">
                    <strong>Database:</strong> {dataSource.database}
                </Typography>
                <Typography variant="body1" paragraph color="text.primary">
                    <strong>Schema:</strong> {dataSource.schema}
                </Typography>
                {allowedRoles.length > 0 && (
                    <Box sx={{ marginTop: 1 }}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            Allowed Roles:
                        </Typography>
                        {allowedRoles.map((role, index) => (
                            <Chip key={index} label={role} size="small" sx={{ marginRight: 0.5, marginBottom: 0.5 }} />
                        ))}
                    </Box>
                )}
            </Card>
        </Grid>
    );
};

export default SnowflakeDataSourceDetail;
